/**
 * AppSumo lifetime tiers. They differ from each other only in credit volume,
 * never capability: backend entitlements grant every tier every model, and
 * there is no subscription above them to upgrade into.
 */
export const APPSUMO_PLAN_SLUGS: ReadonlySet<string> = new Set([
  'appsumo-t1',
  'appsumo-t2',
  'appsumo-t3',
  'appsumo-t4',
  'appsumo-t5',
])

const SUBSCRIPTION_TOP_PLAN_SLUGS: ReadonlySet<string> = new Set([
  'pro',
  'enterprise',
])

export function isAppSumoPlan(planSlug: string | null | undefined): boolean {
  return !!planSlug && APPSUMO_PLAN_SLUGS.has(planSlug.toLowerCase())
}

/**
 * Whether the org is already on a plan with nothing to upgrade to, so
 * "Upgrade" prompts must not be shown.
 *
 * Decided by slug. The display name is only a fallback for a balance payload
 * that carries no slug: matching names alone is how AppSumo lifetime buyers
 * ("AppSumo Tier 3") were told to upgrade to get models they already have.
 */
export function isTopPlan(
  planSlug: string | null | undefined,
  planName?: string | null,
): boolean {
  if (planSlug) {
    const slug = planSlug.toLowerCase()
    return SUBSCRIPTION_TOP_PLAN_SLUGS.has(slug) || APPSUMO_PLAN_SLUGS.has(slug)
  }
  return !!planName && /^(pro|enterprise)$/i.test(planName)
}
